import { registerLocale, getNames } from "@cospired/i18n-iso-languages";
import langsEN from "@cospired/i18n-iso-languages/langs/en.json";

/** codes without country names:
 * zh, da, en, el, he, hi, ja, ko, fa, sw, ta, te, uk, ur, zu
 * */


const supportedLanguages = [
  "ar",
  "bn",
  "bg",
  "ca",
  "zh",
  "hr",
  "cs",
  "da",
  "nl",
  "en",
  "et",
  "fi",
  "fr",
  "de",
  "el",
  "gu",
  "he",
  "hi",
  "hu",
  "is",
  "id",
  "it",
  "ja",
  "kn",
  "ko",
  "lv",
  "lt",
  "ml",
  "mr",
  "no",
  "fa",
  "pl",
  "pt",
  "pa",
  "ro",
  "ru",
  "sk",
  "sl",
  "es",
  "sw",
  "sv",
  "ta",
  "te",
  "th",
  "tr",
  "uk",
  "ur",
  "vi",
  "zu"
]

export const getLanguageList = (tFunction, lang) => {
  registerLocale(langsEN);
  const names = getNames(lang);
  
  return [
    { id: "detect", name: tFunction("common.lang_detect") },
    ...supportedLanguages
      .map(lang => ({
        id: lang,
        name: names[lang]
      }))
  ];
}